/* eslint-disable import/no-anonymous-default-export */
import * as React from 'react';
const QuoteList = React.lazy(() => import('./QuoteList'));

export default {
    list: QuoteList,
};
